import { getFullUrl } from 'hubspot-url-utils';
export const getIFrameEmbedCode = ({
  startTime,
  lessonId,
  contentId,
  shortId,
  language
}) => {
  const searchParams = new URLSearchParams(Object.assign({}, language ? {
    language
  } : {}, startTime ? {
    startTime: startTime.toString()
  } : {}, shortId ? {
    shortId: shortId.toString()
  } : {}, lessonId && contentId ? {
    lessonId: lessonId.toString(),
    contentId: contentId.toString()
  } : {}));
  if (!lessonId && !contentId && !shortId || lessonId && !contentId) {
    return;
  }
  const isLocal = /^local/.test(document.location.hostname);
  const iframeSrc = `${getFullUrl(isLocal ? 'local' : 'app')}/embedded-academy-ui/static?${searchParams}`;
  return `<iframe width="100%" style="aspect-ratio: 16/9" title="Academy embed video" frameborder="0" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen allow="autoplay; fullscreen" src="${iframeSrc}"></iframe>`;
};